import { Size, Variant } from '.';
import { darkButton, lgButton, lightButton, magentaButton, mdButton, smButton } from './style';

export const getCssByVariant = (variant?: Variant) => {
  switch (variant) {
    case 'dark':
      return darkButton;
    case 'magenta':
      return magentaButton;
    default:
      return lightButton;
  }
};

export const getCssBySize = (size?: Size) => {
  switch (size) {
    case 'lg':
      return lgButton;
    case 'sm':
      return smButton;
    default:
      return mdButton;
  }
};

export function getLoadingVariant(variant?: Variant) {
  switch (variant) {
    case 'dark':
    case 'magenta':
      return 'light';
    default:
      return 'magenta';
  }
}
